import { vuexEventPathGenerator } from '@/utils';
export const getterType = {
    getterShareInfoConfigHubId: 'getterShareInfoConfigHubId',
    getterHubStoreList: 'getterHubStoreList',
    getterHubStoreCheckedList: 'getterHubStoreCheckedList',
    getterHubStoreListLength: 'getterHubStoreListLength',
    getterHubStoreSearchOptionField: 'getterHubStoreSearchOptionField',
    getterHubStoreSearchOptionValue: 'getterHubStoreSearchOptionValue',
    getterHubStoreCheckedListLength: 'getterHubStoreCheckedListLength',
    getterRegisteredShareStoreList: 'getterRegisteredShareStoreList',
    getterCurrentShareInfoConfigStoreList: 'getterCurrentShareInfoConfigStoreList',
    getterCurrentRegisteredShareStoreInfoList: 'getterCurrentRegisteredShareStoreInfoList',
    getterRegisteredShareStoreCheckedList: 'getterRegisteredShareStoreCheckedList',
    getterRegisteredShareStoreListLength: 'getterRegisteredShareStoreListLength',
    getterRegisteredShareStoreSearchOptionField: 'getterRegisteredShareStoreSearchOptionField',
    getterRegisteredShareStoreSearchOptionValue: 'getterRegisteredShareStoreSearchOptionValue',
    getterRegisteredShareStoreCheckedListLength: 'getterRegisteredShareStoreCheckedListLength',
};
export const shareConfigGetterType = vuexEventPathGenerator(getterType, 'shareManagement/shareConfig');
const shareConfigGetters = {
    [getterType.getterShareInfoConfigHubId]: ({ shareInfoConfig }) => shareInfoConfig?.hubId,
    [getterType.getterHubStoreList]: ({ totalSubscribeHubStoreList, registeredShareStoreInfo, subscribeHubStoreInfo, }) => {
        const filteredSubscribeInfoList = totalSubscribeHubStoreList.filter((subscribeInfo) => {
            const isExisted = registeredShareStoreInfo.list.some((registeredInfo) => subscribeInfo.storeId === registeredInfo.storeId);
            return !isExisted;
        });
        const { field, value, } = subscribeHubStoreInfo.searchOption;
        if (!value) {
            return filteredSubscribeInfoList;
        }
        return filteredSubscribeInfoList.filter((info) => info[field].includes(value));
    },
    [getterType.getterHubStoreCheckedList]: ({ subscribeHubStoreInfo, }) => subscribeHubStoreInfo.checkedList,
    [getterType.getterHubStoreListLength]: (state, getters) => getters[getterType.getterHubStoreList].length,
    [getterType.getterHubStoreSearchOptionField]: ({ subscribeHubStoreInfo, }) => subscribeHubStoreInfo.searchOption.field,
    [getterType.getterHubStoreSearchOptionValue]: ({ subscribeHubStoreInfo, }) => subscribeHubStoreInfo.searchOption.value,
    [getterType.getterHubStoreCheckedListLength]: ({ subscribeHubStoreInfo, }) => subscribeHubStoreInfo.checkedList.length,
    [getterType.getterRegisteredShareStoreList]: ({ registeredShareStoreInfo, }) => {
        const { field, value } = registeredShareStoreInfo.searchOption;
        if (!value) {
            return registeredShareStoreInfo.list;
        }
        return registeredShareStoreInfo.list.filter((info) => info[field].includes(value));
    },
    [getterType.getterCurrentShareInfoConfigStoreList]: ({ shareInfoConfig }) => shareInfoConfig
        ?.formattedStores,
    [getterType.getterCurrentRegisteredShareStoreInfoList]: ({ registeredShareStoreInfo }) => registeredShareStoreInfo
        .list,
    [getterType.getterRegisteredShareStoreCheckedList]: ({ registeredShareStoreInfo }) => registeredShareStoreInfo
        .checkedList,
    [getterType.getterRegisteredShareStoreListLength]: (state, getters) => getters[getterType.getterRegisteredShareStoreList].length,
    [getterType.getterRegisteredShareStoreSearchOptionField]: ({ registeredShareStoreInfo }) => registeredShareStoreInfo
        .searchOption.field,
    [getterType.getterRegisteredShareStoreSearchOptionValue]: ({ registeredShareStoreInfo }) => registeredShareStoreInfo
        .searchOption.value,
    [getterType.getterRegisteredShareStoreCheckedListLength]: ({ registeredShareStoreInfo }) => registeredShareStoreInfo
        .checkedList.length,
};
export default shareConfigGetters;
